import type { RecurringCharge } from "@/lib/types/recurring-charges";
import type { DetailPageConfig } from "@/components/shared/UniversalDetailPage/types/detailPage";
import { RECURRING_CHARGES_CONFIG } from "@/features/recurring-charges/components/RecurringChargesConfig";
import { ENHANCED_RECURRING_CHARGE_DETAIL_CONFIG } from "@/features/recurring-charges/components/RecurringChargeDetailConfig";
import { getFieldValue } from "@/components/shared/UniversalCRMTable/components/SimpleTable/tableCellFieldValue";
import { defineEntity } from "../types";

// ============================================================================
// RECURRING CHARGES ENTITY DEFINITION
// ============================================================================
// Column change: edit features/recurring-charges/components/RecurringChargesConfig.ts.
// Note: ENHANCED_RECURRING_CHARGE_DETAIL_CONFIG is not typed as DetailPageConfig — cast required.
// ============================================================================

export const recurringChargesEntity = defineEntity<RecurringCharge>({
  tableConfig: RECURRING_CHARGES_CONFIG,

  // Untyped detail config — cast to satisfy EntityDefinition contract
  detailConfig: ENHANCED_RECURRING_CHARGE_DETAIL_CONFIG as unknown as DetailPageConfig<RecurringCharge>,

  synthesizeField(item, fieldId) {
    return getFieldValue(item, fieldId);
  },
});
